import { useMemo } from "react";
import { MediaBaseUrl } from "../../../../../../actions/api"
import { GET_NETWORK_ICON, showAddAccountAlertNew } from "../../../../../../utils";

const ConnectNetwork = ({ id, name }) => {

    const onAddAccount = () => {
        showAddAccountAlertNew({ id, name }, "addFeed");
    }

    const netIcon = useMemo(() => {
        const icon = GET_NETWORK_ICON(id);
        return `${MediaBaseUrl}social-icons/${icon}.svg`
    }, [id]);

    return (
        <div className="form-group text-start">
            <div className="py-3">
                <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3" onClick={onAddAccount}>
                    <span className="symbol symbol-25 me-3">
                        <img src={netIcon} alt={name} />
                    </span>
                    <span className="text-dark-50 font-weight-bolder font-size-base">Connect {name}</span>
                </a>
            </div>
        </div>
    )
}

export default ConnectNetwork